import { FC } from "react"
import { NewWindowIcon as MarmaladeNewWindowIcon } from "@eventbrite/marmalade"

export interface NewWindowIconProps {
  size?: "xxsmall" | "xsmall" | "small" | "medium" | "large" | "xlarge"
  className?: string
  color?: string
}

export const NewWindowIcon: FC<NewWindowIconProps> = ({ 
  size = "xxsmall", 
  className = "",
  color = "currentColor"
}) => {
  return (
    <>
      &nbsp;
      <MarmaladeNewWindowIcon
        size={size}
        className={className}
        color={color}
        aria-label="Opens in new window"
        style={{ 
          display: 'inline-block',
          verticalAlign: 'baseline',
          transform: 'translateY(2px)'
        }}
      />
    </>
  )
}

export default NewWindowIcon
